export interface CalendarAccountsResponse {
  providers: CalendarProviderGroup[];
  summary: CalendarAccountsSummary;
}

export interface CalendarAccountsSummary {
  provider_count: number;
  account_count: number;
  calendar_count: number;
  selected_count: number;
  provider_error_count: number;
  account_error_count: number;
}

export interface CalendarProviderGroup {
  provider: string;
  display_name: string;
  icon?: CalendarProviderIcon | null;
  capabilities: CalendarProviderCapabilities;
  accounts: CalendarAccount[];
  error?: CalendarProviderError | null;
}

export interface CalendarProviderIcon {
  type: string;
  value: string;
}

export interface CalendarProviderCapabilities {
  can_connect_accounts: boolean;
  can_read_busy: boolean;
  can_read_events: boolean;
  can_write_events: boolean;
  connect_mode?: CalendarProviderConnectMode;
}

// app_specific_password: connect by posting an account email and app-specific
// password (iCloud). Providers without a mode connect through OAuth.
export type CalendarProviderConnectMode = 'app_specific_password';

export interface CalendarProviderError {
  code: string;
  message: string;
}

export interface CalendarAccount {
  connection_id: string;
  provider_user_id?: string;
  email?: string;
  name?: string;
  picture_url?: string;
  status: string;
  calendars: ExternalCalendar[];
  error?: CalendarAccountError | null;
}

export interface CalendarAccountError {
  code: string;
  message: string;
  reconnect_required?: boolean;
}

export interface ExternalCalendar {
  id: string;
  provider_calendar_id: string;
  summary: string;
  description?: string;
  primary?: boolean;
  hidden?: boolean;
  access_role?: string;
  background_color?: string;
  foreground_color?: string;
  time_zone?: string;
  capabilities: ExternalCalendarCapabilities;
  selected_for_conflicts: boolean;
  selected_for_event_copies?: boolean | null;
}

export interface ExternalCalendarCapabilities {
  can_read_busy: boolean;
  can_read_events: boolean;
  can_write_events: boolean;
}

export interface UpdateConflictCalendarSelectionRequest {
  provider: string;
  connection_id: string;
  provider_calendar_id: string;
  selected: boolean;
}

export interface DisconnectCalendarAccountRequest {
  provider: string;
  connection_id: string;
}

export interface ConnectICloudCalendarRequest {
  email: string;
  app_specific_password: string;
}

export type CalendarSelectionOverrides = Record<string, boolean>;
export type CalendarSelectionErrors = Record<string, number>;

export function calendarSelectionKey(
  provider: string,
  connectionId: string,
  providerCalendarId: string
): string {
  return `${provider}\u001f${connectionId}\u001f${providerCalendarId}`;
}
